import { z } from "zod";

export enum MagicLinkIdCardUploadMethod {
    You = "you",
    Client = "client",
}

export const MagicLinkIdCardUploadMethodSchema = z.nativeEnum(MagicLinkIdCardUploadMethod);

